import { Typography, Divider } from '@unity/cloud-ui';

import { AccordionGroup, Accordion } from './accordion';
import { Important, Note, Tip, Warning } from './admonitions';
import { Card, CardGrid } from './card';
import { Code, CodeGroup } from './code';
import { Expandable } from './expandable';
import { Field, FieldGroup } from './field';
import { Frame } from './frame';
import { GlossaryTerm } from './glossary-term';
import { Header } from './header';
import { Icon } from './icon';
import { Image } from './image';
import { Link } from './link';
import { List } from './list';
import { ListItem } from './list-item';
import { ListGroup } from './list-group';
import { Mermaid } from './mermaid';
import { PreformattedText } from './preformatted-text';
import { Step, Steps } from './steps';
import { Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from './table';
import { Tabs, Tab } from './tabs';
import { VideoEmbed } from './video-embed';

const components = {
  a: Link,
  h1: (props) => <Header {...props} variant="h1" />,
  h2: (props) => <Header {...props} variant="h2" />,
  h3: (props) => <Header {...props} variant="h3" />,
  h4: (props) => <Header {...props} variant="h4" />,
  h5: (props) => <Header {...props} variant="h5" />,
  h6: (props) => <Header {...props} variant="h6" />,
  code: Code,
  pre: PreformattedText,
  p: (props) => <Typography {...props} variant="body1" component="span" />,
  ul: (props) => <List {...props} component="ul" />,
  ol: (props) => <List {...props} component="ol" />,
  li: ListItem,
  hr: Divider,
  img: (props) => <Image {...props} />,

  // see https://github.com/Unity-Technologies/webcix-hexadocs/blob/main/app/_domains/mdx-module/MDXPage.tsx#L58
  AccordionGroup,
  Accordion,
  Card,
  CardGrid,
  CardGroup: CardGrid,
  Caution: Warning,
  CodeGroup,
  Expandable,
  Field,
  FieldGroup,
  Frame,
  GlossaryTerm,
  Icon,
  Important,
  ListItem,
  ListGroup,
  Mermaid,
  Note,
  Step,
  Steps,
  Table,
  TableHeader,
  TableHeaderCell,
  TableBody,
  TableRow,
  TableCell,
  table: Table,
  thead: TableHeader,
  th: TableHeaderCell,
  tbody: TableBody,
  tr: TableRow,
  td: TableCell,
  Tabs,
  Tab,
  Tip,
  VideoEmbed,
  Warning,
};

export default components;
